import { ApiProperty } from '@nestjs/swagger';

/** The signed-in user, as much as the admin needs to bootstrap. */
export class AuthUserDto {
  @ApiProperty({ type: 'string', format: 'uuid' })
  readonly id!: string;

  @ApiProperty()
  readonly email!: string;

  @ApiProperty()
  readonly firstName!: string;

  @ApiProperty()
  readonly lastName!: string;

  @ApiProperty({
    description:
      'True when a subdivision of the user regions runs the Drywall and Paint workflow.',
  })
  readonly showTNReports!: boolean;
}

/**
 * Token pair plus the user and its role names, so the admin bootstraps from
 * the sign-in response alone (it used to GET /user/me, user-role and role).
 */
export class AuthResponseDto {
  @ApiProperty()
  readonly accessToken: string;

  @ApiProperty()
  readonly refreshToken: string;

  @ApiProperty({ type: () => AuthUserDto })
  readonly user: AuthUserDto;

  @ApiProperty({ type: [String], description: 'Role names of the user.' })
  readonly roles: string[];

  constructor(
    accessToken: string,
    refreshToken: string,
    user: AuthUserDto,
    roles: string[],
  ) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.user = user;
    this.roles = roles;
  }
}
